import {Trans} from '@lingui/macro';
import React from 'react';

import {SettingsAppsTabsEnum} from '../../../models/url/settingsUrlModel';

/*
 * Helpers.
 */

export function renderSettingsAppsTabName(tab: SettingsAppsTabsEnum) {
  switch (tab) {
    case SettingsAppsTabsEnum.COLLECTIONS:
      return <Trans id="settings-apps-tab-collections">Collections</Trans>;
    case SettingsAppsTabsEnum.CATEGORIES:
      return <Trans id="settings-apps-tab-categories">Categories</Trans>;
    case SettingsAppsTabsEnum.POPULAR:
      return <Trans id="settings-apps-tab-popular">Popular</Trans>;
    case SettingsAppsTabsEnum.PLUGINS:
      return <Trans id="settings-apps-tab-plugins">Plugins</Trans>;
    case SettingsAppsTabsEnum.CHANNELS:
      return <Trans id="settings-apps-tab-channels">Channels</Trans>;
    case SettingsAppsTabsEnum.ENABLED:
      return <Trans id="settings-apps-tab-enabled">Enabled</Trans>;
    case SettingsAppsTabsEnum.ALL:
      return <Trans id="settings-apps-tab-all">All</Trans>;
    default:
      return null;
  }
}

export function computeSettingsAppsTabFromPreviousUrl(url: string) {
  if (url.includes(SettingsAppsTabsEnum.COLLECTIONS)) {
    return SettingsAppsTabsEnum.COLLECTIONS;
  }
  if (url.includes(SettingsAppsTabsEnum.CATEGORIES)) {
    return SettingsAppsTabsEnum.CATEGORIES;
  }
  if (url.includes(SettingsAppsTabsEnum.POPULAR)) {
    return SettingsAppsTabsEnum.POPULAR;
  }
  if (url.includes(SettingsAppsTabsEnum.PLUGINS)) {
    return SettingsAppsTabsEnum.PLUGINS;
  }
  if (url.includes(SettingsAppsTabsEnum.CHANNELS)) {
    return SettingsAppsTabsEnum.CHANNELS;
  }
  if (url.includes(SettingsAppsTabsEnum.ENABLED)) {
    return SettingsAppsTabsEnum.ENABLED;
  }
  if (url.includes(SettingsAppsTabsEnum.ALL)) {
    return SettingsAppsTabsEnum.ALL;
  }
  return undefined;
}
